import React, { Component } from "react";

import { HomeSlider, HomeTitle, Img } from "../../Components/UI/UI";

import { getWeather } from "../../Utility/Utility";

import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "./CoronaVirus.css";

class CoronaVirus extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    getWeather((Weather) => {
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    return (
      <div className="page align-left page-Corona-virus">
        <Menu />
        <HomeSlider
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />

        <div className="container">
          <p>
            I disse udfordrende tider står vi i Israel sammen med jer, det
            danske folk, og har jer med i vores bønner. Vi står sammen i håbet
            om en lysere, bedre fremtid.
          </p>

          {/*  <h1>REJSEVEJLEDNING &amp; SIKKERHEDSINFORMATION FOR REJSE TIl ISRAEL</h1>*/}

          <h2 className="ac-pink">
            Seneste information ang. CORONAVIRUS (COVID-19) for rejsende til
            Israel
          </h2>

          {/* <h2 className="ac-pink">Israel har meddelt yderligere genåbningsforanstaltninger</h2>

             <p>Fra den 1. juni har Israels sundhedsministerium annonceret en række yderligere genåbningsforanstaltninger, blandt andet åbning af restauranter, turistattraktioner og hoteller.</p>
             <p>Strandene blev åbnet den 20. maj.</p>
             <p>Fra den 27. maj 2020 har restauranter, barer, pubber og klubber lov til at åbne med visse begrænsninger. Fritids- og turistattraktioner såsom hoteller, museer og svømmebassiner er også blevet tilladt at genåbne med visse begrænsninger.</p>
             <p>Israels Sundhedsministerium har også vedtaget at øge bus- og taxapassagerkapaciteten samt at genoptage togaktiviteten fra 8. juni.</p>
             <p>Underholdning og fritidsaktiviteter genoptages den 14. juni, herunder events, parker og forlystelsesparker, koncerter, teatre, biografer og kulturelle begivenheder, med visse begrænsninger.</p>
             <p>I turistsektoren har flere lande annonceret, at de åbner deres grænser for israelske borgere herunder: Grækenland, Østrig, Montenegro, Georgien og nu Cypern (gældende pr.  9. juni).</p>
             <p>Internationale flyselskaber som Delta Airlines, British Airways, Air Canada, Wizz Air, Ryanair, Lufthansa, Turkish Airlines, Alitalia, Ukrainian International m.fl. har meddelt, at de agter at genoptage kommercielle flyvninger til og fra Israel denne sommer.</p>  */}

          <h2 className="ac-pink ac-margin-top-1 ac-bigger">
            Turister der påtænker at rejse til Israel:
          </h2>

          <p>
            I særlige tilfælde kan man ansøge det Israelske udenrigsministerie
            om godkendelse til indrejse i landet, såfremt du kan bevise, at du
            kan gå i selvisolation i 14 dage i tilfælde af smitte.
          </p>

          <h2 className="ac-pink ac-margin-top-1 ac-bigger">
            Generelle retningslinjer for alle, der opholder sig i Israel:
          </h2>

          <ul>
            <li>
              For the latest information on coronavirus cases in Israel, please
              refer to the Department of Health's{" "}
              <a
                href="https://govextra.gov.il/ministry-of-health/corona/corona-virus-en/"
                target="_blank"
              >
                website
              </a>
              .
            </li>
            <li>
              The Israeli Government is monitoring the outbreak closely and has
              implemented temporary measures including border restrictions for
              travellers from around the world.
            </li>
            <li>
              People showing symptoms are not permitted to accompany patients or
              visit institutions for seniors.
            </li>
          </ul>

          <ul>
            <li>
              For aktuelle informationer om coronavirus-tilfælde i Israel
              henvises til den Israelske sundhedsministeriums hjemmeside.
            </li>
            <li>
              Den israelske regering monitorerer nøje udbruddet og har iværksat
              midlertidige foranstaltninger, herunder restriktioner ved grænsen
              for rejsende fra hele verden.
            </li>
            <li>
              Personer med symptomer må ikke ledsage patienter eller besøge
              institutioner for ældre.
            </li>
          </ul>

          <h2 className="ac-pink ac-margin-top-1 ac-bigger">Vigtigt!</h2>

          <ul>
            <li>
              Hvis du er blevet påbudt at gå i selvisolation,
              <strong className="ac-pink">
                skal du rapportere det til det Israelske sundhedsministerium:{" "}
                <a href="https://www.govforms.gov.il" target="_blank">
                  www.govforms.gov.il/
                </a>
              </strong>
            </li>
            <li>
              Hvis du får feber på 100,4F (38C) eller derover, hoste,
              åndedrætsbesvær eller andre åndedrætssymptomer,{" "}
              <strong>
                skal du straks gå i selvisolation og ringe til 101 MDA Emergency
                Services Hotline for medicinsk rådgivning.
              </strong>
            </li>
            <li>
              <strong className="ac-pink">
                Det er absolut forbudt at besøge sundhedsklinikker, lægehuse
                eller hospitaler, hvis du viser nogen af ovenstående symptomer!
              </strong>
            </li>
          </ul>

          <h2 className="ac-pink ac-margin-top-1 ac-bigger">
            Ofte stillede spørgsmål
          </h2>

          <ol>
            <li>
              Jeg er turist i Israel og er bekymret for, at jeg måske har
              COVID-19, hvor skal jeg henvende mig?
            </li>
            <li>
              Hvis du har feber på 100,4F (38C) eller derover, hoste,
              åndedrætsbesvær eller andre åndedrætssymptomer, skal du straks gå
              i selvisolation og ringe til 101 MDA Emergency Services Hotline
              for medicinsk rådgivning.
              <br />{" "}
              <strong className="ac-pink">
                Gå ikke til en sundhedsklinik, lægehus eller hospital.
              </strong>
              &nbsp;
            </li>
            <li>
              <b className="ac-pink">
                Hvornår vil Israel igen åbne for indrejsende turister?
              </b>
              &nbsp; På nuværende tidspunkt er der ikke officielt udmeldt en
              dato, for hvornår Israel igen åbner for indrejsende turister.
            </li>
          </ol>

          <Img desktopImg={"infection.jpg"} />
        </div>

        <Footer />
      </div>
    );
  }
}

export default CoronaVirus;



// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirusDK.js